import { SupportedAudioFileType } from "@/types/types";
import { isSupportedFileType } from "@/utils/typeGuards/isSupportedFileType";

export const parseSupportedAudioFileType = (
  fileType: unknown
): SupportedAudioFileType => {
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (!fileType || !isSupportedFileType(fileType)) {
    throw new Error("Missing or incorrect file type", { cause: fileType });
  }

  return fileType;
};
